import React from 'react'
import { navigateTo } from 'gatsby-link';
import logo from './logo/logo-low-res.png';
import { Divider, Label, Sidebar, Menu, Image, Icon, Button, Visibility, Grid, Segment, Container } from 'semantic-ui-react'
import styles from './header.module.css';
import { slash } from '../../utils/utils'

class Header extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      activeItem: 'none',
      visible: false,
      calculations: {
        direction: 'none',
        height: 0,
        width: 0,
        topPassed: false,
        bottomPassed: false,
        pixelsPassed: 0,
        percentagePassed: 0,
        topVisible: false,
        bottomVisible: false,
        fits: false,
        passing: false,
        onScreen: false,
        offScreen: false
      }
    }
  }

  handleUpdate = (e, { calculations }) => {
    this.setState({ calculations })
  }

  handleMenuClick = (name, url) =>  {
    this.setState({ activeItem: name })
    this.setState({ visible: !this.state.visible })
    navigateTo(url);
  };

  render() {
    const breakpoints = [
      { width: 800, right: 3, mid: 4, left: 9},
      { width: 1000, right: 3, mid: 5, left: 8},
      { width: 1200, right: 3, mid: 6, left: 7},
      { width: 1400, right: 3, mid: 7, left: 6},
      { width: 1600, right: 3, mid: 7, left: 6},
    ];
    const { calculations, contextRef } = this.state;
    const { width } = this.state.calculations;
    const links = [
      { title:'HOME', url: '/', icon: 'home' },
      { title:'COURSE', url: '/courses', icon: 'book' },
      { title:'UNIVERSITY', url: '/universities', icon: 'building outline' },
      { title:'SCHOLARSHIP', url: '/scholarships', icon: 'student' }];

    const LongHeader = ({width}) => {
      const { activeItem } = this.state
      const { right, mid, left } = breakpoints.reduce((acc, x) => {
        if(Object.keys(acc).length > 0) { return acc; }
        if(width < x.width) { return x }
        return acc;
      }, {});

      return <Grid>
        <Grid.Row stretched>
          <Grid.Column width={right} className={styles.img}>
          <Image src={logo} />
          </Grid.Column>
          <Grid.Column width={mid} />
          <Grid.Column width={left} className={styles.leftMenu}>
            <Menu secondary compact>
            {links.map(({title, url},y) => {
              return <Menu.Item key={"menu-" + y} name={title}
                active={activeItem === title} onClick={ () => this.handleMenuClick(title, url) } href={slash(url)}>
                </Menu.Item>
            })}
            </Menu>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    };

    const toggle = () => {
        this.setState({ visible: !this.state.visible })
        const visible = this.state.visible;
    }

    const SideMenu = () => {
      const visible = this.state.visible;
      return <Grid verticalAlign='middle' >
      <Grid.Row verticalAlign='middle' stretched>
        <Grid.Column width={6}>
          <Image src={logo} className={styles.img} size='huge'/>
        </Grid.Column>
        <Grid.Column width={7} />
        <Grid.Column width={3}>
          <Icon color='blue' name='sidebar' size='big' onClick={() => {toggle()}}/>
          <Sidebar as={Menu} animation='overlay' width='thin' direction='right'
            visible={visible} icon='labeled' vertical >
            <Label attached='top left'>
              <Icon name='close' onClick={() => {toggle()}} />
            </Label>
            {links.map(({title, url, icon},y) => {
              return <Menu.Item key={"menu-" + y} name={title} onClick={ () => this.handleMenuClick(title, url) } href={slash(url)} >
              <Icon name={icon} />{title}
              </Menu.Item>
            })}
            <Menu.Item name='info circle'>
              <Icon name='info circle' />ABOUT US
            </Menu.Item>
            <Menu.Item name='protect'>
              <Icon name='protect' />PRIVACY
            </Menu.Item>
          </Sidebar>
        </Grid.Column>
      </Grid.Row>
      <Divider hidden />
      </Grid>
    };

    return <Visibility fireOnMount onUpdate={this.handleUpdate}>
      <div className={styles.container}>
      <Divider hidden />
      { width > 700 && <LongHeader width={width} /> }
      { width < 700 && <SideMenu /> }
      <Divider hidden fitted />
      </div>
    </Visibility>
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js